import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'lucide-react';
import toast, { Toaster } from 'react-hot-toast';
import { formConfig } from './productFormConfig';
import axios from 'axios';
import AssetSelectionModal from '../onBoardingAsset/AssetSelectionModal';
import heartLoading from "../../../../assests/heartLoading.gif"
import OnboardProductFormSections from '../../OnBoardingProduct/components/OnboardProductFormSections';
import OnboardProductActions from '../../OnBoardingProduct/components/OnboardProductActions';
import OnboardProductLoadingOverlay from '../../OnBoardingProduct/components/OnboardProductLoadingOverlay';
import { ChevronDown } from 'lucide-react';

const OnboardProduct = ({ onNext, userRole }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoadingCodes, setIsLoadingCodes] = useState(false);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [proudctId, setProductId] = useState("")
  const [selectedFile, setSelectedFile] = useState(null);
  const [formData, setFormData] = useState({
    // Basic Information
    productName: '',
    productCode: '',
    description: '',
    dataLayer: '',

    // Market Information
    marketRegion: [],
    lineOfBusiness: '',

    //Hierarchy Information
    hierarchy_1: '',
    hierarchy_2: '',
    hierarchy_3: '',
    hierarchy_4: '',
    hierarchy_5: '',

    // Cost Information
    developmentCosts: [],
    supportCosts: [],
    operationCosts: [],
    costThreshold: '',
    sizeThreshold: '',
    sizeThresholdUnit: '',

    // Additional Information
    expectedUsers: '',
    valueMapping: '',
    azureServicesCost: '',
    domain: '',
    subDomain: '',
    subSubDomain: '',
    slaResponseTimeUnit: '',
        assignment_group: '',
    assetSource: [],
    productOwner: '',
    productTag: [],
    productDocumentationUrl: '',
    marketCountry: [],
    parentRegions: [],
    reportObjective: '',
    keyDecisionSupported: '',
    reportLink: '',
    reportType: [],
    reportSections: [],
    reportOwner: '',
  });
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [productCodeOptions, setProductCodeOptions] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState('');
  const [domainData, setDomainData] = useState([]);
  const [reportTypes, setReportTypes] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedSubDomain, setSelectedSubDomain] = useState(null);
  const [selectedSubSubDomain, setSelectedSubSubDomain] = useState(null);
  const [subdomainOptions, setSubdomainOptions] = useState([]);
  const [subSubdomainOptions, setSubSubdomainOptions] = useState([]);
  const [isDomainEditMode, setIsDomainEditMode] = useState(false);
  const [isMarketEditMode, setIsMarketEditMode] = useState(id ? false : true);
  const [regionsCountriesData, setRegionsCountriesData] = useState([]);
  const [parentRegionOptions, setParentRegionOptions] = useState([]);
  const [selectedParentRegions, setSelectedParentRegions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [hasInitializedParentRegions, setHasInitializedParentRegions] = useState(false);
  const [domainId, setDomainId] = useState("");
  const [subDomainId, setSubDomainId] = useState("");
  const [subSubDomainId, setSubSubDomainId] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [fileConfigurations, setFileConfigurations] = useState({});
   const [hasUploaded, sethasUploaded] = useState(false);
  const [configForm, setConfigForm] = useState({
    assetName: '',
    assetDescription: '',
    dataAssetOwner: '',
    region: '',
    market: '',
    technicalDataSteward: '',
    refreshFrequency: '',
    completeness: '',
    accuracy: '',
    consistency: '',
  });
  const [formErrors, setFormErrors] = useState({});
  const [productNameOptions, setProductNameOptions] = useState([]);
  const [selectedProductName, setSelectedProductName] = useState('');
  const [isProductOwnerEmailValid, setIsProductOwnerEmailValid] = useState(true);
  const [openSections, setOpenSections] = useState({
    basicInformation: true,  // Open by default
    marketInformation: false,
    hierarchyInformation: false,
    costInformation: false,
    serviceLevelAgreement: false,
    additionalInformation: false,
    reportInformation: false
  });

  const toggleSection = (sectionKey) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionKey]: !prev[sectionKey]
    }));
  };

  // console.log("selectedProductNmae", selectedProductName)

  console.log("formData", formData)

  // console.log("domain data", domainData)
  console.log("Parent domain id", domainId)
  console.log("domainId", subDomainId);
  console.log("subDomainId", subSubDomainId)


  console.log("formData", formData)

  const findRegionByName = useCallback((regionName) => {
    if (!regionName || !regionsCountriesData?.length) return null;
    for (const parent of regionsCountriesData) {
      const region = parent.regions?.find((r) => r.region === regionName);
      if (region) {
        return { ...region, parentRegion: parent.parent_region };
      }
    }
    return null;
  }, [regionsCountriesData]);

  const getRegionsForParentValues = useCallback((parentValues = []) => {
    if (!parentValues.length || !regionsCountriesData?.length) return [];
    const results = [];
    parentValues.forEach((value) => {
      const parent = regionsCountriesData.find(
        (entry) => entry.parent_region === value
      );
      if (parent?.regions?.length) {
        parent.regions.forEach((region) => {
          results.push({
            value: region.region,
            label: region.region,
            parentRegion: value,
          });
        });
      }
    });
    return results;
  }, [regionsCountriesData]);

  const getCountriesDataForSelections = useCallback((regionSelections = []) => {
    const seenCountries = new Set();
    const options = [];
    regionSelections.forEach((selection) => {
      const regionData = findRegionByName(selection.value);
      regionData?.countries?.forEach((country) => {
        if (!seenCountries.has(country)) {
          seenCountries.add(country);
          options.push({ value: country, label: country });
        }
      });
    });

    return {
      countryOptions: options,
      countryValues: options.map((option) => option.value),
    };
  }, [findRegionByName]);

  const deriveParentRegionsFromMarket = useCallback((marketRegions = []) => {
    const parentSet = new Set();
    (marketRegions || []).forEach((regionValue) => {
      const regionData = findRegionByName(regionValue);
      if (regionData?.parentRegion) {
        parentSet.add(regionData.parentRegion);
      }
    });
    return Array.from(parentSet);
  }, [findRegionByName]);

  const applyRegionSelection = useCallback((regionSelections = []) => {
    setSelectedRegions(regionSelections);
    const {
      countryOptions: nextCountryOptions,
      countryValues,
    } = getCountriesDataForSelections(regionSelections);
    setCountryOptions(nextCountryOptions);
    setFormData((prev) => ({
      ...prev,
      marketRegion: regionSelections.map((selection) => selection.value),
      marketCountry: countryValues,
    }));
  }, [getCountriesDataForSelections]);

  // Allowed email domains
  const ALLOWED_EMAIL_DOMAINS = ['effem.com'];

  // Validate product owner email
  const validateProductOwnerEmail = (email) => {
    if (!email || email.trim() === '') {
      return true; // Empty email is considered valid for save functionality
    }
    const emailPattern = /^[^\s@]+@([^\s@]+)$/;
    const match = email.match(emailPattern);
    if (!match) return false;

    const domain = match[1];
    return ALLOWED_EMAIL_DOMAINS.includes(domain);
  };

  // Validate dates in cost periods
  const validateDates = () => {
    const costTypes = ['developmentCosts', 'supportCosts', 'operationCosts'];

    for (const costType of costTypes) {
      if (formData[costType] && formData[costType].length > 0) {
        for (const period of formData[costType]) {
          // Skip validation if cost is 0 or empty (dates are not required)
          if (!period.cost || period.cost <= 0) {
            continue;
          }

          // Check if dates are provided when cost is provided
          if (!period.startDate || !period.endDate) {
            toast.error(`Please provide both start and end dates for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }

          // Validate date format and values
          const startDate = new Date(period.startDate);
          const endDate = new Date(period.endDate);

          // Check if dates are valid
          if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            toast.error(`Please provide valid dates for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }

          // Check if start date is before end date
          if (startDate >= endDate) {
            toast.error(`End date must be after start date for ${costType.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }
        }
      }
    }

    return true;
  };

  // Update email validation state when productOwner changes
  useEffect(() => {
    const isValid = validateProductOwnerEmail(formData.productOwner);
    setIsProductOwnerEmailValid(isValid);
  }, [formData.productOwner]);

  useEffect(() => {
    const fetchEditData = async () => {
      if (!id) return;
      try {
        setIsLoadingDetails(true);
        // Reset parent region initialization flag for edit mode
        setHasInitializedParentRegions(false);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/edit-form/${id}`);
        if (response.status === 200 && response.data) {
          const data = response.data;
          // Map API response to formData, skipping 'N/A' values
          const newFormData = { ...formData };
          const fieldMap = {
            productName: 'productName',
            productCode: 'productCode',
            description: 'description',
            productOwner: 'productOwner',
            hierarchy_1: 'hierarchy_1',
            hierarchy_2: 'hierarchy_2',
            hierarchy_3: 'hierarchy_3',
            hierarchy_4: 'hierarchy_4',
            hierarchy_5: 'hierarchy_5',
            dataLayer: 'dataLayer',
            lineOfBusiness: 'lineOfBusiness',
            costThreshold: 'costThreshold',
            valueMapping: 'valueMapping',
            azureServicesCost: 'azureServicesCost',
            assignment_group: 'assignment_group',
            productTag: 'productTag',
            productDocumentationUrl: 'productDocumentationUrl',
            minExpectedUsers: 'minExpectedUsers',
            maxExpectedUsers: 'maxExpectedUsers',
            status: 'status',
          };
          Object.entries(fieldMap).forEach(([apiKey, formKey]) => {
            if (data[apiKey] !== undefined && data[apiKey] !== 'N/A') {
              newFormData[formKey] = data[apiKey];
            }
          });
          if (data.reportDetails && typeof data.reportDetails === 'object') {
            const reportDetails = data.reportDetails;

            if (reportDetails.reportObjective && reportDetails.reportObjective !== 'N/A') {
              newFormData.reportObjective = reportDetails.reportObjective;
            }

            if (reportDetails.keyDecisionSupport && reportDetails.keyDecisionSupport !== 'N/A') {
              newFormData.keyDecisionSupported = reportDetails.keyDecisionSupport;
            }

            if (reportDetails.reportLink && reportDetails.reportLink !== 'N/A') {
              newFormData.reportLink = reportDetails.reportLink.trim();
            }

            if (reportDetails.reportOwner && reportDetails.reportOwner !== 'N/A') {
              newFormData.reportOwner = reportDetails.reportOwner;
            }

            if (Array.isArray(reportDetails.reportSections)) {
              newFormData.reportSections = reportDetails.reportSections;
            }

            if (reportDetails.reportIds) {


              newFormData.reportTypeId = reportDetails.reportIds;
            }
          }
          // Handle market region and country as arrays
          if (data.marketRegion && data.marketRegion !== 'N/A') {
            const marketRegions = Array.isArray(data.marketRegion) ? data.marketRegion : [data.marketRegion];
            newFormData.marketRegion = marketRegions;
            setSelectedRegions(marketRegions.map(region => ({ value: region, label: region })));
          }

          if (data.marketCountry && data.marketCountry !== 'N/A') {
            const marketCountries = Array.isArray(data.marketCountry) ? data.marketCountry : [data.marketCountry];
            newFormData.marketCountry = marketCountries;
          }
          setSelectedProductName(newFormData?.productName)
          // Nested fields
          if (data.sizeThreshold && data.sizeThreshold.value !== 'N/A') {
            newFormData.sizeThreshold = data.sizeThreshold.value;
            newFormData.sizeThresholdUnit = data.sizeThreshold.unit !== 'N/A' ? data.sizeThreshold.unit : '';
          }
              if (data.assignment_group && data.assignment_group !== 'N/A') {
        newFormData.assignment_group = data.assignment_group;
        }
          // Array fields
          ['developmentCosts', 'supportCosts', 'operationCosts'].forEach(arrKey => {
            if (Array.isArray(data[arrKey]) && data[arrKey].length > 0 && data[arrKey][0].cost !== 'N/A') {
              newFormData[arrKey] = data[arrKey];
            }
          });
          // Domain fields (IDs)
          if (data.parentDomainId && data.parentDomainId !== 'N/A') setDomainId(data.parentDomainId);
          if (data.domainId && data.domainId !== 'N/A') setSubDomainId(data.domainId);
          if (data.subDomainId && data.subDomainId !== 'N/A') setSubSubDomainId(data.subDomainId);
          newFormData.domain = data?.parentDomainName || "";
          newFormData.subDomain = data?.domainName || "";
          newFormData.subSubDomain = data?.subDomainName || ""
          //  newFormData.assetSource = data?.assetSource
          console.log("asset, sources", data.assetSource)

          const assetSourceLabels = {
            adls: 'ADLS',
            uc: 'UC',
            manual: 'Manual'
          };

          const normalizeToArray = (input) => {
            if (!input) return [];
            return Array.isArray(input) ? input : [input];
          };

          newFormData.assetSource = normalizeToArray(data?.assetSource).map((key) => ({
            value: key,
            label: assetSourceLabels[key] || key.toUpperCase()
          }));
          if (Array.isArray(data.reportSections) && data.reportSections.length > 0) {
            newFormData.reportSections = data.reportSections;
          }

          if (Array.isArray(data.reportType) && data.reportType.length > 0) {
            const reportTypeLabels = {
              uc: 'UC',
              adls: 'ADLS',
              manual: 'Manual'
            };
            newFormData.reportType = data.reportType.map(type => ({
              value: type,
              label: reportTypeLabels[type] || type.toUpperCase()
            }));
          }
          // Set form data
          setFormData(newFormData);
          // Optionally, set selectedProductCode if editing
          if (data.productCode && data.productCode !== 'N/A') setSelectedProductCode(data.productCode);
        }
      } catch (error) {
        toast.error('Failed to fetch product for editing');
      } finally {
        setIsLoadingDetails(false);
      }
    };
    fetchEditData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);


  // Fetch product codes and domain data on component mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch product names
        setIsLoadingCodes(true);
        const productNamesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/product-names`);
        if (productNamesResponse.status === 200) {
          // productNames
          const names = productNamesResponse.data.productNames.map(name => ({
            value: name,
            label: name
          }));
          setProductNameOptions(names);
        }
        const reportTypesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/report-types`);
        if (reportTypesResponse.status === 200) {
          const types = reportTypesResponse.data.reportTypes.map(type => ({
            value: type.id,
            label: type.type
          }));
          setReportTypes(types);
        }
        const domainResponse = await axios.get(`${process.env.REACT_APP_API_URL}/parentdomain_domain_subdomain_list/`);
        if (domainResponse.status === 200) {
          setDomainData(domainResponse.data.parent_domains);
        }
        // Fetch regions and countries
        const regionsCountriesResponse = await axios.get(`${process.env.REACT_APP_API_URL}/regions-countries-list/v2`);
        if (regionsCountriesResponse.status === 200) {
          const parentRegionPayload = regionsCountriesResponse.data || [];
          setRegionsCountriesData(parentRegionPayload);
          setParentRegionOptions(
            parentRegionPayload.map((item) => ({
              value: item.parent_region,
              label: item.parent_region,
            }))
          );
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        toast.error('Failed to fetch initial data');
      } finally {
        setIsLoadingCodes(false);
      }
    };
    fetchInitialData();
  }, []);
  useEffect(() => {
    localStorage.setItem("assetSource", JSON.stringify(formData.assetSource))
  }, [formData.assetSource])


  // Update subdomain options when domain changes
  useEffect(() => {
    if (selectedDomain) {
      const parentDomain = domainData.find(d => d.parent_domain_id === selectedDomain.value);
      if (parentDomain) {
        const subdomains = parentDomain.domains.map(domain => ({
          value: domain.domain_id,
          label: domain.domain
        }));
        setSubdomainOptions(subdomains);
        setSubSubdomainOptions([]); // Reset sub-subdomain options
      }
    } else {
      setSubdomainOptions([]);
      setSubSubdomainOptions([]);
    }
  }, [selectedDomain, domainData]);

  useEffect(() => {
    if (reportTypes.length > 0 && formData.reportTypeId && !formData.reportType?.length) {
      const matchingReportType = reportTypes.find(
        type => type.value === formData.reportTypeId
      );

      if (matchingReportType) {
        setFormData(prev => ({
          ...prev,
          reportType: [matchingReportType],
          reportTypeId: undefined // Clean up temporary field
        }));
      }
    }
  }, [reportTypes, formData.reportTypeId, formData.reportType]);
  // Update sub-subdomain options when subdomain changes
  useEffect(() => {
    if (selectedSubDomain && selectedDomain) {
      const parentDomain = domainData.find(d => d.parent_domain_id === selectedDomain.value);
      if (parentDomain) {
        const domain = parentDomain.domains.find(d => d.domain_id === selectedSubDomain.value);
        if (domain) {
          const subSubdomains = domain.sub_domains.map(sub => ({
            value: sub.sub_domain_id,
            label: sub.sub_domain
          }));
          setSubSubdomainOptions(subSubdomains);
        }
      }
    } else {
      setSubSubdomainOptions([]);
    }
  }, [selectedSubDomain, selectedDomain, domainData]);

  useEffect(() => {
    if (
      hasInitializedParentRegions ||
      !regionsCountriesData.length ||
      selectedParentRegions.length
    ) {
      return;
    }

    const existingParentValues =
      formData.parentRegions && formData.parentRegions.length
        ? formData.parentRegions
        : deriveParentRegionsFromMarket(formData.marketRegion);

    if (!existingParentValues || !existingParentValues.length) {
      return;
    }

    const uniqueParentValues = Array.from(new Set(existingParentValues));
    const parentSelections = uniqueParentValues
      .map((value) => {
        const option = parentRegionOptions.find(
          (parentOption) => parentOption.value === value
        );
        return option || { value, label: value };
      })
      .filter(Boolean);

    if (!parentSelections.length) return;

    setSelectedParentRegions(parentSelections);

    const availableRegions = getRegionsForParentValues(uniqueParentValues);
    setRegionOptions(availableRegions);

    const initialRegions = availableRegions.filter((region) =>
      (formData.marketRegion || []).includes(region.value)
    );

    applyRegionSelection(initialRegions);

    if (
      !formData.parentRegions ||
      formData.parentRegions.length !== uniqueParentValues.length ||
      uniqueParentValues.some(
        (value) => !formData.parentRegions.includes(value)
      )
    ) {
      setFormData((prev) => ({
        ...prev,
        parentRegions: uniqueParentValues,
      }));
    }

    setHasInitializedParentRegions(true);
  }, [
    applyRegionSelection,
    deriveParentRegionsFromMarket,
    formData.marketRegion,
    formData.parentRegions,
    getRegionsForParentValues,
    hasInitializedParentRegions,
    parentRegionOptions,
    regionsCountriesData,
    selectedParentRegions.length,
  ]);

  useEffect(() => {
    if (!selectedRegions.length) {
      setCountryOptions([]);
      return;
    }

    const {
      countryOptions: nextCountryOptions,
      countryValues,
    } = getCountriesDataForSelections(selectedRegions);

    setCountryOptions(nextCountryOptions);
    setFormData((prev) => ({
      ...prev,
      marketCountry: countryValues,
    }));
  }, [getCountriesDataForSelections, selectedRegions]);

  // Edit mode: fetch and populate form if id is present


  const handleDomainChange = (selectedOption) => {
    setSelectedDomain(selectedOption);
    setSelectedSubDomain(null);
    setSelectedSubSubDomain(null);
    setFormData(prev => ({
      ...prev,
      domain: selectedOption ? selectedOption.value : '',
      subDomain: '',
      subSubDomain: ''
    }));
  };

  const handleSubdomainChange = (selectedOption) => {
    setSelectedSubDomain(selectedOption);
    setSelectedSubSubDomain(null);
    setFormData(prev => ({
      ...prev,
      subDomain: selectedOption ? selectedOption.value : '',
      subSubDomain: ''
    }));
  };

  const handleSubSubdomainChange = (selectedOption) => {
    setSelectedSubSubDomain(selectedOption);
    setFormData(prev => ({
      ...prev,
      subSubDomain: selectedOption ? selectedOption.value : ''
    }));
  };

  const handleParentRegionChange = (selectedOptions) => {
    const parentSelections = selectedOptions || [];
    setSelectedParentRegions(parentSelections);

    const parentValues = parentSelections.map((option) => option.value);
    const availableRegions = getRegionsForParentValues(parentValues);
    setRegionOptions(availableRegions);

    // Auto-select all market regions when parent regions are selected
    if (parentSelections.length > 0) {
      applyRegionSelection(availableRegions);
    } else {
      // If no parent regions selected, clear market regions
      applyRegionSelection([]);
    }

    setFormData((prev) => ({
      ...prev,
      parentRegions: parentValues,
    }));
  };

  const handleRegionChange = (selectedOptions) => {
    applyRegionSelection(selectedOptions || []);
  };

  const handleCountryChange = (selectedOptions) => {
    setFormData(prev => ({
      ...prev,
      marketCountry: selectedOptions ? selectedOptions.map(option => option.value) : []
    }));
  };

  const handleProductNameSelect = async (selectedOption) => {
    if (!selectedOption) return;
    setSelectedProductName(selectedOption.value);
    setFormData(prev => ({ ...prev, productName: selectedOption.value }));
    try {
      setIsLoadingDetails(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product-details/${selectedOption.value}`);
      if (response.status === 200) {
        const details = response.data;
        setFormData(prev => ({
          ...prev,
          productCode: details.product_code || '',
          description: details.product_description || '',
          dataLayer: details.dataLayer || '',
          domain: details.parent_domain_name || '',
          subDomain: details.domain || '',
          subSubDomain: details.sub_domain || '',
          productOwner: details.product_owner || ''
        }));
        setDomainId(details.parent_domain_id);
        setSubDomainId(details.domain_id);
        setSubSubDomainId(details.sub_domain_id);
      }
    } catch (error) {
      console.error('Error fetching product details:', error);
      toast.error('Failed to fetch product details');
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handleProductCodeSelect = async (selectedOption) => {
    if (!selectedOption) return;

    setSelectedProductCode(selectedOption.value);
    setFormData(prev => ({ ...prev, productCode: selectedOption.value }));

    try {
      setIsLoadingDetails(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/product-details/${selectedOption.value}`);
      // console.log('Product details response:', response.data);

      if (response.status === 200) {
        const details = response.data;

        setFormData(prev => ({
          ...prev,
          productName: details.product_name || '',
          description: details.product_description || '',
          dataLayer: details.dataLayer || '',
          domain: details.parent_domain_name || '',  // This is the parent domain name
          subDomain: details.domain || '',          // This is the domain
          subSubDomain: details.sub_domain || '',   // This is the sub domain
          productOwner: details.product_owner || ''
        }));

        // Set IDs for reference
        setDomainId(details.parent_domain_id);
        setSubDomainId(details.domain_id);
        setSubSubDomainId(details.sub_domain_id);

        // Log the values to verify
        console.log('Setting domain values:', {
          parentDomainName: details.parent_domain_name,
          domain: details.domain,
          subDomain: details.sub_domain,
          formDataDomain: details.parent_domain_name
        });
      }
    } catch (error) {
      console.error('Error fetching product details:', error);
      toast.error('Failed to fetch product details');
    } finally {
      setIsLoadingDetails(false);
    }
  };

  console.log(formData);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if user is Data Engineer or Vendor
    const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
    if (dataEngineerVendorRoles.includes(userRole)) {
      toast.error('You are not authorized to submit this form.');
      return;
    }
    if (formData.dataLayer === "analyticalProduct") {
      const reportFields = [
        { name: 'reportObjective', label: 'Report Objective' },
        { name: 'keyDecisionSupported', label: 'Key Decision Supported' },
        { name: 'reportLink', label: 'Report Link' },
        { name: 'reportType', label: 'Report Type' },
        { name: 'reportSections', label: 'Report Sections' },
        { name: 'reportOwner', label: 'Report Owner' }
      ];

      const missingFields = reportFields.filter(field => {
        const value = formData[field.name];
        return !value || value === '' || (Array.isArray(value) && value.length === 0);
      });

      

      if (missingFields.length > 0) {
        toast.error(`Please fill in required report fields: ${missingFields.map(f => f.label).join(', ')}`);
        return;
      }

      if (formData.reportOwner && !formData.reportOwner.toLowerCase().endsWith("@effem.com")) {
        toast.error("Report owner email must end with @effem.com");
        return;
      }
    }
    if (!validateForm()) {
      return;
    }

    // Validate dates before proceeding
    if (!validateDates()) {
      return;
    }

    try {
      setIsSubmitting(true);

      const selectedDomainObj = domainData.find(d => d.domain_id === formData.domain);
      const selectedSubdomainObj = selectedDomainObj?.sub_domains.find(s => s.sub_domain_id === formData.subDomain);

      const submitData = {
        ...formData,
        sizeThreshold: {
          value: formData.sizeThreshold !== undefined && formData.sizeThreshold !== null && formData.sizeThreshold !== '' ? formData.sizeThreshold : null,
          unit: formData.sizeThresholdUnit || ""
        },
              assignment_group: formData.assignment_group || '',
        reportDetails: formData.dataLayer === "analyticalProduct" ? {
          reportObjective: formData.reportObjective || "",
          keyDecisionSupport: formData.keyDecisionSupported || "",
          reportLink: formData.reportLink || "",
          reportSections: formData.reportSections || [],
          reportOwner: formData.reportOwner || "",
          reportIds: formData.reportType?.[0]?.value || null,
        } : null,
        azureServicesCost: formData.azureServicesCost !== undefined && formData.azureServicesCost !== null && formData.azureServicesCost !== '' ? formData.azureServicesCost : null,
        costThreshold: formData.costThreshold !== undefined && formData.costThreshold !== null && formData.costThreshold !== '' ? formData.costThreshold.toString() : '',
        // slaResponseTime: formData.slaResponseTime.toString(),
        parentDomainId: !isDomainEditMode ? domainId : selectedDomain?.value || '',
        parentDomain: !isDomainEditMode ? formData.domain : selectedDomain?.label || '',
        domainId: !isDomainEditMode ? subDomainId : selectedSubDomain?.value || '',
        domain: !isDomainEditMode ? formData.subDomain : selectedSubDomain?.label || '',
        subDomainId: !isDomainEditMode ? subSubDomainId : selectedSubSubDomain?.value || '',
        subDomain: !isDomainEditMode ? formData.subSubDomain : selectedSubSubDomain?.label || '',
        assetSource: formData.assetSource?.map(source => source.value) || [],
        // slaUptime: formData.slaUptime !== undefined && formData.slaUptime !== null && formData.slaUptime !== '' ? formData.slaUptime.toString() : '',
        minExpectedUsers: formData.minExpectedUsers !== undefined && formData.minExpectedUsers !== null && formData.minExpectedUsers !== '' ? formData.minExpectedUsers.toString() : '',
        maxExpectedUsers: formData.maxExpectedUsers !== undefined && formData.maxExpectedUsers !== null && formData.maxExpectedUsers !== '' ? formData.maxExpectedUsers.toString() : '',
        status: 'submit',
        marketRegion: formData.marketRegion,
        marketCountry: formData.marketCountry,
        hierarchy_1: formData.hierarchy_1,
        hierarchy_2: formData.hierarchy_2,
        hierarchy_3: formData.hierarchy_3,
        hierarchy_4: formData.hierarchy_4,
        hierarchy_5: formData.hierarchy_5,
      };

      ['domain', 'subDomain', 'subSubDomain', 'parentDomain', 'sizeThresholdUnit', 'expectedUsers', 'parentRegions', 'reportType', 'reportObjective', 'keyDecisionSupported', 'reportLink', 'reportSections', 'reportOwner'].forEach(key => {
        if (submitData.hasOwnProperty(key)) {
          delete submitData[key];
        }
      });

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-product`, submitData);

      if (response.status === 200 || response.status === 201) {
        toast.success('Product onboarded successfully! You can now proceed to the next step.');
        setProductId(response?.data?.product_id)
        // setShowAssetModal(true)
        localStorage.setItem("selectionId", response?.data?.product_id)
        onNext();
      } else {
        throw new Error('Failed to onboard product');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error(error.response?.data?.message || 'Something went wrong while onboarding the product. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSaveDraft = async () => {
    // Check if user is Data Engineer or Vendor
    const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
    if (dataEngineerVendorRoles.includes(userRole)) {
      toast.error('You are not authorized to save drafts.');
      return;
    }

    // Validate product name is selected
    if (!formData.productName || formData.productName.trim() === '') {
      toast.error('Please select Product Name first');
      return;
    }

    // Validate email if provided
    if (formData.productOwner && formData.productOwner.trim() !== '') {
      if (!validateProductOwnerEmail(formData.productOwner)) {
        toast.error(`Please enter a valid email address for Product Owner from: ${ALLOWED_EMAIL_DOMAINS.join(', ')}`);
        return;
      }
    }

    // Validate dates before proceeding (even for draft saves)
    if (!validateDates()) {
      return;
    }

    try {
      setIsSaving(true);

      const selectedDomainObj = domainData.find(d => d.domain_id === formData.domain);
      const selectedSubdomainObj = selectedDomainObj?.sub_domains.find(s => s.sub_domain_id === formData.subDomain);

      const submitData = {
        ...formData,
        sizeThreshold: {
          value: formData.sizeThreshold !== undefined && formData.sizeThreshold !== null && formData.sizeThreshold !== '' ? formData.sizeThreshold : null,
          unit: formData.sizeThresholdUnit || ""
        },
            assignment_group: formData.assignment_group || '',
        reportDetails: formData.dataLayer === "analyticalProduct" ? {
          reportObjective: formData.reportObjective || "",
          keyDecisionSupport: formData.keyDecisionSupported || "",
          reportLink: formData.reportLink || "",
          reportSections: formData.reportSections || [],
          reportOwner: formData.reportOwner || "",
          reportIds: formData.reportType?.[0]?.value || null,
        } : null,
        azureServicesCost: formData.azureServicesCost !== undefined && formData.azureServicesCost !== null && formData.azureServicesCost !== '' ? formData.azureServicesCost : null,
        costThreshold: (formData.costThreshold || '').toString(),
        // slaResponseTime: formData.slaResponseTime.toString(),
        parentDomainId: !isDomainEditMode ? domainId : selectedDomain?.value || '',
        parentDomain: !isDomainEditMode ? formData.domain : selectedDomain?.label || '',
        domainId: !isDomainEditMode ? subDomainId : selectedSubDomain?.value || '',
        domain: !isDomainEditMode ? formData.subDomain : selectedSubDomain?.label || '',
        subDomainId: !isDomainEditMode ? subSubDomainId : selectedSubSubDomain?.value || '',
        subDomain: !isDomainEditMode ? formData.subSubDomain : selectedSubSubDomain?.label || '',
        assetSource: formData.assetSource?.map(source => source.value) || [],
        // slaUptime: (formData.slaUptime || '').toString(),
        minExpectedUsers: (formData.minExpectedUsers || '').toString(),
        maxExpectedUsers: (formData.maxExpectedUsers || '').toString(),
        status: 'save',
        marketRegion: formData.marketRegion,
        marketCountry: formData.marketCountry,
        hierarchy_1: formData.hierarchy_1,
        hierarchy_2: formData.hierarchy_2,
        hierarchy_3: formData.hierarchy_3,
        hierarchy_4: formData.hierarchy_4,
        hierarchy_5: formData.hierarchy_5,
      };

      ['domain', 'subDomain', 'subSubDomain', 'parentDomain', 'sizeThresholdUnit', 'expectedUsers', 'parentRegions', 'reportObjective', 'keyDecisionSupported', 'reportLink', 'reportSections', 'reportOwner', 'reportType',].forEach(key => {
        if (submitData.hasOwnProperty(key)) {
          delete submitData[key];
        }
      });

      let payload = submitData;

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/submit-product`, submitData);

      if (response.status === 200 || response.status === 201) {
        toast.success('Draft saved successfully!');
      } else {
        throw new Error('Failed to save draft');
      }
    } catch (error) {
      console.error('Error saving draft:', error);
      toast.error(error.response?.data?.message || 'Something went wrong while saving the draft. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  const addCostPeriod = (type) => {
    const newPeriod = {
      id: Date.now().toString(),
      startDate: '',
      endDate: '',
      cost: ''
    };
    setFormData({
      ...formData,
      [type]: [...formData[type], newPeriod]
    });
  };

  const removeCostPeriod = (type, id) => {
    setFormData({
      ...formData,
      [type]: formData[type].filter(period => period.id !== id)
    });
  };

  const updateCostPeriod = (type, id, field, value) => {
    setFormData({
      ...formData,
      [type]: formData[type].map(period =>
        period.id === id ? { ...period, [field]: value } : period
      )
    });
  };

  const validateForm = () => {
    const requiredFields = Object.values(formConfig)
      .flatMap(section =>
        section.fields ? section.fields :
          section.thresholds ? section.thresholds : []
      )
      .filter(field => field.required)
      .map(field => field.name);

    const missingFields = requiredFields.filter(field => {
      if (field === 'assetSource') {
        return !formData[field] || formData[field].length === 0;
      }
      if (field === 'productTag') {
        return !formData[field] || formData[field].length === 0;
      }
      if (field === 'developmentCosts' || field === 'supportCosts' || field === 'operationCosts') {
        return !formData[field] || formData[field].length === 0;
      }
      return !formData[field];
    });

    if (missingFields.length > 0) {
      const fieldLabels = missingFields.map(field => {
        const section = Object.values(formConfig).find(section =>
          section.fields?.find(f => f.name === field) ||
          section.thresholds?.find(t => t.name === field)
        );
        const fieldConfig = section?.fields?.find(f => f.name === field) ||
          section?.thresholds?.find(t => t.name === field);
        return fieldConfig?.label || field;
      });
      toast.error(`Please fill in all required fields: ${fieldLabels.join(', ')}`);
      return false;
    }

    // Validate email format if email field exists (any valid email)
    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        toast.error('Please enter a valid email address');
        return false;
      }
    }

    // Validate productOwner email format (only effem.com domain)
    if (formData.productOwner) {
      const emailPattern = /^[^\s@]+@([^\s@]+)$/;
      const match = formData.productOwner.match(emailPattern);
      if (!match || !ALLOWED_EMAIL_DOMAINS.includes(match[1])) {
        toast.error(`Please enter a valid email address for Product Owner from: ${ALLOWED_EMAIL_DOMAINS.join(', ')}`);
        return false;
      }
    }

    // Validate cost periods
    const costTypes = ['developmentCosts', 'supportCosts', 'operationCosts'];
    for (const costType of costTypes) {
      if (formData[costType].length > 0) {
        const invalidPeriods = formData[costType].filter(
          period => !period.startDate || !period.endDate || period.cost === '' || period.cost === null || period.cost === undefined || period.cost < 0
        );
        if (invalidPeriods.length > 0) {
          toast.error(`Please fill in all required fields for ${costType}`);
          return false;
        }
      }
    }

    // Validate SLA Uptime is between 1 and 100
 

    // Validate URL field for Product Documentation
    if (formData.productDocumentationUrl) {
      const urlRegex = /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/;
      if (!urlRegex.test(formData.productDocumentationUrl)) {
        toast.error('Please enter a valid URL for product documentation');
        return false;
      }
    }

    // Validate description character limit
    if (formData.description && formData.description.length > 10000) {
      toast.error('Product description cannot exceed 10000 characters');
      return false;
    }

    return true;
  };

  const allFilesConfigured = uploadedFiles.every(file => fileConfigurations[file.id]);

  // Check if user is Data Engineer or Vendor
  const dataEngineerVendorRoles = ['Data Engineer', 'Vendor'];
  const isDataEngineerOrVendor = userRole ? dataEngineerVendorRoles.includes(userRole) : false;

  return (
    <>
      <div className="max-w-[90%] mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-[#bb1ccc]">Onboard Data Product</h2>
              <p className="mt-1 text-sm text-gray-500">
                Provide basic information about your data product
              </p>
            </div>
            <div className="flex items-center justify-center">
              <div className="bg-blue-100 rounded-full p-3">
                <Box className="h-8 w-8 text-blue-600 m-auto" />
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-6">
            <OnboardProductLoadingOverlay
              isVisible={isLoadingCodes || isLoadingDetails}
              imageSrc={heartLoading}
            />

            <OnboardProductFormSections
              formConfig={formConfig}
              formData={formData}
              setFormData={setFormData}
              productNameOptions={productNameOptions}
              selectedProductName={selectedProductName}
              handleProductNameSelect={handleProductNameSelect}
              handleProductCodeSelect={handleProductCodeSelect}
              isLoadingCodes={isLoadingCodes}
              isLoadingDetails={isLoadingDetails}
              isSubmitting={isSubmitting}
              reportTypes={reportTypes}
              regionsCountriesData={regionsCountriesData}
              parentRegionOptions={parentRegionOptions}
              selectedParentRegions={selectedParentRegions}
              handleParentRegionChange={handleParentRegionChange}
              regionOptions={regionOptions}
              selectedRegions={selectedRegions}
              handleRegionChange={handleRegionChange}
              countryOptions={countryOptions}
              handleCountryChange={handleCountryChange}
              selectedDomain={selectedDomain}
              handleDomainChange={handleDomainChange}
              selectedSubDomain={selectedSubDomain}
              handleSubdomainChange={handleSubdomainChange}
              selectedSubSubDomain={selectedSubSubDomain}
              handleSubSubdomainChange={handleSubSubdomainChange}
              subdomainOptions={subdomainOptions}
              subSubdomainOptions={subSubdomainOptions}
              domainData={domainData}
              isDomainEditMode={isDomainEditMode}
              setIsDomainEditMode={setIsDomainEditMode}
              isMarketEditMode={isMarketEditMode}
              setIsMarketEditMode={setIsMarketEditMode}
              addCostPeriod={addCostPeriod}
              removeCostPeriod={removeCostPeriod}
              updateCostPeriod={updateCostPeriod}
              ALLOWED_EMAIL_DOMAINS={ALLOWED_EMAIL_DOMAINS}
              isProductOwnerEmailValid={isProductOwnerEmailValid}
              isEditMode={Boolean(id)}
              openSections={openSections}
              toggleSection={toggleSection}
               sethasUploaded={sethasUploaded}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
            />

            <OnboardProductActions
              isDataEngineerOrVendor={isDataEngineerOrVendor}
              handleSaveDraft={handleSaveDraft}
              isSaving={isSaving}
              isSubmitting={isSubmitting}
              isLoadingCodes={isLoadingCodes}
              isLoadingDetails={isLoadingDetails}
              allFilesConfigured={allFilesConfigured}
              hasUploaded={hasUploaded}
            />
          </form>
        </div>


      </div> <Toaster position="top-right" />
    </>
  );
};

export default OnboardProduct;
